<template>
	<div class="sampleSpecs">
		<el-table :data="skuList" class="table" :span-method="spanMethod" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column label="选择寄样规格" width="130">
				<template v-slot="{ row }">
					<el-button type="primary" plain @click="selectSku" :disabled="!row.hasSku">选择规格</el-button>
				</template>
			</el-table-column>
			<el-table-column label="规格" width="180">
				<template slot="header">
					<div>
						<span class="yx-color-danger">*</span>
						<span class="ml-4">规格</span>
					</div>
				</template>
				<template v-slot="{ row }">
					<p class="fz-12 line-clamp-2" v-if="row.hasSku">{{ row.specification | formatEmpty }}</p>
					<p class="yx-color-warning font-h6-regular" v-else>
						<i class="el-icon-warning"></i>
						<span class="ml-4">未获取到规格</span>
					</p>
				</template>
			</el-table-column>
			<el-table-column label="现售价" width="100">
				<template v-slot="{ row }">
					<p class="fz-12">{{ row.price | formatEmpty | formatPrice }}</p>
				</template>
			</el-table-column>
			<el-table-column label="申样数量" width="160">
				<template v-slot="{ row }">
					<el-input-number
						v-if="row.hasSku && row.id"
						v-model="row.num"
						controls-position="right"
						@change="handleChange"
						size="mini"
						:min="0"
						:precision="0"
					></el-input-number>
					<span v-else>-</span>
				</template>
			</el-table-column>
			<el-table-column label="规格备注" min-width="100">
				<template v-slot="{ row }">
					<p class="font-h6-regular">{{ specification_remark }}</p>
					<i class="el-icon-edit-outline cursor-pointer hover" @click="addRemark(specification_remark)"></i>
				</template>
			</el-table-column>
		</el-table>
		<div class="footer flex-row font-h6-regular yx-color-text-regular">
			<p style="width: 130px" class="yx-color-text-primary yx-color-text-regular">合计</p>
			<p style="width: 180px"></p>
			<p style="width: 100px" class="yx-color-text-primary">{{ totalPrice | formatPrice }}</p>
			<p class="flex-1">{{ total }}</p>
		</div>
		<addSkuDrawer ref="addSkuDrawer" :platformId="platformId" @handleAddSku="handleAddSku" />
		<remarkDialog ref="remarkDialog" @editRemark="editRemark" />
	</div>
</template>
<script>
import addSkuDrawer from '@/components/business/addSkuDrawer';
import remarkDialog from './components/remarkDialog.vue';
export default {
	name: 'sampleSpecs',
	components: {
		addSkuDrawer,
		remarkDialog,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		productId: {
			type: String,
			default: '',
		},
		remark: {
			type: String,
			default: '',
		},
		platformId: {
			type: String,
			default: '1',
		},
	},
	watch: {
		list: {
			handler(to) {
				this.skuList = to;
				if (to.length && to[0].skuId) {
					this.selectList = this.skuList;
				}
			},
			deep: true,
			immediate: true,
		},
		remark: {
			handler(to) {
				this.specification_remark = to;
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		totalPrice({ skuList }) {
			if (!skuList.length) return 0;
			if (!skuList[0].hasSku) return 0;

			let price = skuList
				.reduce((prev, item) => {
					return Number(item.price) * item.num + prev;
				}, 0)
				.toFixed(2);
			return price || 0;
		},
		total({ skuList }) {
			if (!skuList.length) return 0;
			if (!skuList[0].hasSku) return 0;
			return skuList.filter(item => item.num).length;
		},
	},
	data() {
		return {
			skuList: [],
			selectList: [],
			specification_remark: '',
		};
	},
	methods: {
		handleChange() {
			this.$emit('change', this.skuList, this.specification_remark);
		},
		// 合并单元格方法
		spanMethod({ row: { rowspan, colspan }, column, rowIndex, columnIndex }) {
			if ([0, 4].includes(columnIndex)) {
				if (rowIndex === 0) {
					return {
						rowspan: this.skuList.length,
						colspan: 1,
					};
				} else {
					return {
						rowspan: 0,
						colspan: 1,
					};
				}
			}
			return {
				rowspan: 1,
				colspan: 1,
			};
		},
		reset() {
			this.selectList = [];
		},
		selectSku() {
			const { productId } = this;
			// 展示添加sku抽屉
			this.$refs.addSkuDrawer.show(productId, this.skuList);
		},
		handleAddSku(val) {
			let arr = val.map((item, index) => {
				return {
					...item,
					num: 1,
					hasSku: true,
					ramerk: '',
				};
			});
			this.selectList = [...this.selectList, ...arr];
			this.skuList = this.selectList;
			this.$emit('change', this.skuList, this.specification_remark);
		},
		addRemark(remark) {
			this.$refs.remarkDialog.show(remark);
		},
		editRemark(val) {
			this.specification_remark = val;
			this.$emit('change', this.skuList, this.specification_remark);
		},
	},
};
</script>
<style lang="less" scoped>
.sampleSpecs {
	::v-deep .el-table .el-table__cell {
		vertical-align: top;
	}
	::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
		background-color: #ffffff;
	}
	/deep/ .table-sample-row td {
		border: none !important;
		padding: 6px 0px;
	}
	/deep/ .el-input-number--mini {
		width: 110px;
	}
	/deep/ .el-table__body-wrapper {
		max-height: 300px;
		overflow-y: auto;
		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @border-color-lighter;
		}
	}
	::v-deep .table-header-row {
		.el-table__cell {
			padding: 8px 0px;
		}
	}
	.footer {
		padding: 14px 0px;
		background-color: #f7f8fa;
		border-radius: 2px;
		p {
			padding: 0px 16px;
			box-sizing: border-box;
		}
	}
	::v-deep .el-table__row:first-child td:first-child {
		border-right: 1px solid @border-color-base;
	}
	::v-deep .el-table__row:first-child td:last-child {
		border-left: 1px solid @border-color-base;
	}
}
.table::before {
	height: 0 !important;
}
</style>
